// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MemoDetails_MemoFragment = { __typename?: 'Memo', id: string, name: string, content?: string | null, tenantID: string, createdAt: Time, updatedAt: Time, entryMode?: Types.MemoEntryMode | null, specificInstructions?: string | null, aiRating?: Types.MemoAiRating | null, aiFeedback?: string | null, memoPrompt?: { __typename?: 'MemoPrompt', id: string, name: string, description: string, memoPromptType: Types.MemoPromptMemoPromptType, promptMarkdown?: string | null } | null, user: { __typename?: 'User', id: string, displayName: string }, updateUser: { __typename?: 'User', id: string, displayName: string }, documents: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: { __typename?: 'Document', id: string, name: string, type: Types.DocumentType, displayType: string } | null } | null> | null } };

export type MemoDetailsQueryVariables = Types.Exact<{
  memoId: Types.Scalars['ID']['input'];
}>;


export type MemoDetailsQuery = { __typename?: 'Query', memos: { __typename?: 'MemoConnection', edges?: Array<{ __typename?: 'MemoEdge', node?: (
        { __typename?: 'Memo' }
        & MemoDetails_MemoFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    MemoDetails: 'MemoDetails' as const
  },
  Fragment: {
    MemoDetails_Memo: 'MemoDetails_Memo' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const MemoDetails_MemoFragmentDoc = gql`
    fragment MemoDetails_Memo on Memo {
  id
  name
  content
  tenantID
  createdAt
  updatedAt
  entryMode
  specificInstructions
  aiRating
  aiFeedback
  memoPrompt {
    id
    name
    description
    memoPromptType
    promptMarkdown
  }
  user {
    id
    displayName
  }
  updateUser {
    id
    displayName
  }
  documents {
    edges {
      node {
        id
        name
        type
        displayType
      }
    }
  }
}
    `;
export const MemoDetailsDocument = gql`
    query MemoDetails($memoId: ID!) {
  memos(where: {id: $memoId}) {
    edges {
      node {
        ...MemoDetails_Memo
      }
    }
  }
}
    ${MemoDetails_MemoFragmentDoc}`;

/**
 * __useMemoDetailsQuery__
 *
 * To run a query within a React component, call `useMemoDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemoDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemoDetailsQuery({
 *   variables: {
 *      memoId: // value for 'memoId'
 *   },
 * });
 */
export function useMemoDetailsQuery(baseOptions: Apollo.QueryHookOptions<MemoDetailsQuery, MemoDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemoDetailsQuery, MemoDetailsQueryVariables>(MemoDetailsDocument, withFetchPolicyContext(options));
      }
export function useMemoDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemoDetailsQuery, MemoDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemoDetailsQuery, MemoDetailsQueryVariables>(MemoDetailsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useMemoDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MemoDetailsQuery, MemoDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemoDetailsQuery, MemoDetailsQueryVariables>(MemoDetailsDocument, withFetchPolicyContext(options));
        }
export type MemoDetailsQueryHookResult = ReturnType<typeof useMemoDetailsQuery>;
export type MemoDetailsLazyQueryHookResult = ReturnType<typeof useMemoDetailsLazyQuery>;
export type MemoDetailsSuspenseQueryHookResult = ReturnType<typeof useMemoDetailsSuspenseQuery>;
export type MemoDetailsQueryResult = Apollo.QueryResult<MemoDetailsQuery, MemoDetailsQueryVariables>;